//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {required, minLength, maxValue, minValue, between, email} from 'vuelidate/lib/validators';
import DateAndTime from "@/components/appointment/DateAndTime.vue";
import DateAndTimeApi from "@/components/appointment/DateAndTimeApi.vue";
import CallBackModal from "~/components/modals/CallBackModal.vue";
import {UserMixin, AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import recordYandexMetrikaTarget from "~/constants/recordYandexMetrikaTarget";
import SpecialistSelect from "~/components/zapis/SpecialistSelect.vue";
import {comagicAddOfflineRequest} from "~/helpers/comagic";
import ZapisSpecialistsCardsList from "~/components/zapis/ZapisSpecialistsCardsList.vue";

export default {
  name: "Form",
  data: function () {
    return {
      isSubmit: false,
      isModalOpen: false,
      workTime: {},
      appointmentTime: {},
      specialistName: "",
      address: "",
      service: {},
      patientName: "",
      middleName: "",
      surname: "",
      childAge: null,
      phone: "",
      form: {
        user: 1,
        name: "",
      },
      email: "",
      mailingAgreement: false,
      isPrivacyPolicy: false,
      isConsentProcessing: false,

      isAppointment: true,
      isShowForm: true,
      isLoadingInitDate: true,

      disabledFormUuid: false,

      selectedSpecialist: null,
    };
  },
  mixins: [UserMixin, AppMixin],
  components: {
    DateAndTime,
    CallBackModal,
    DateAndTimeApi,
    SpecialistSelect,
    ZapisSpecialistsCardsList
  },
  validations: function () {
    const childAge = Boolean(this.form.user === 2) ? {
      required,
      between: between(0, 18)
    } : {};

    let _validations = {
      patientName: {required, minLength: minLength(2)},
      surname: {required, minLength: minLength(2)},
      middleName: {minLength: minLength(2)},
      phone: {required, minLength: minLength(15)},
      appointmentTime: {
        start: {
          required,
        },
      },
      childAge
    }
    if (this.isEmailRequired) {
      _validations.email = {
        required,
        email
      };
    }

    return _validations
  },
  computed: {
    // setTime() {
    //   const startTime = 9;
    //   let timeRange = [];
    //   for (let key = 0; key <= 10; key++) {
    //     timeRange.push({
    //       from: `${key + startTime}:00`,
    //       to: `${key + startTime}:30`,
    //       value: `${key + startTime}:00-${key + startTime}:30`,
    //     });
    //     timeRange.push({
    //       from: `${key + startTime}:30`,
    //       to: `${key + startTime + 1}:00`,
    //       value: `${key + startTime}:30-${key + startTime + 1}:00`,
    //     });
    //   }
    //   return timeRange;
    // },
    servicePrice: function () {
      if (!this.service || !this.service?.price || this.service?.price === 0) {
        return "бесплатно";
      }

      return `${this.service?.price} ₽`;
    },

    // Длительность услуги
    serviceDuration: function () {
      const duration = this.service?.duration;

      const hours = Math.floor(duration / 60);
      const minuts = duration - hours * 60;

      return [
        !!hours
          ? `${hours} ${this.$caseWords(hours, ["час", "часа", "часов"])}`
          : undefined,
        !!minuts
          ? `${minuts} ${this.$caseWords(minuts, [
            "минута",
            "минуты",
            "минут",
          ])}`
          : undefined,
      ].join(" ");
    },

    // Адрес магазина
    addressShop: function () {
      return this.salons.find((t) => t.id === this.formInfo.salon)?.address || "Любой"
    },

    isShowQrCodeMessage: function () {
      return Boolean((this.vars['Уведомление о QR-коде ВКЛ'] || '').toLowerCase() === 'да')
    },

    isApiWorkTime: function () {
      const isSelectSalon = Boolean(!!this.formInfo.salon && this.formInfo.salon !== -1);
      const isSelectService = Boolean(!!this.formInfo.service && this.formInfo.service !== -1);
      return Boolean(isSelectSalon && isSelectService);
    },

    errorEmail: function () {
      const isDirty = Boolean(this.$v?.email?.$dirty);
      if (!isDirty) {
        return ''
      }

      if (!this.$v.email.required) {
        return "Обязательно к заполнению"
      }
      if (!this.$v.email.email) {
        return "Неверный формат"
      }

      return ''
    },
    isEmailRequired: function () {
      return false
    },

    selectedSpecialistId: function () {
      return this.selectedSpecialist?.id || -1
    },
    serviceName: function () {
      return this.service?.name || ''
    }
  },
  async mounted() {
    this.isLoadingInitDate = true;

    let userFromUuid = null;
    if (this.uuid) {
      const _res = await this.$api.agent.transport.get(`/exchange/client/getByExternalId/${ this.uuid }`).then(res => res.data).catch(() => null);
      if (_res) {
        this.phone = _res.phone || "";
        this.surname = _res.last_name || "";
        this.patientName = _res.middle_name || "";
        this.middleName = _res.first_name || "";

        this.disabledFormUuid = true;
      }
    }

    if (!!this.user && !this.uuid) {
      this.patientName = this.user?.name || "";

      let phone = ('' + this.user?.phone).replace(/\D/g, '').substr(1);
      let phoneMatch = phone.match(/^(\d{3})(\d{2})(\d{2})(\d{3})$/);
      this.phone = Boolean(this.user?.phone) ? `(${phoneMatch[1]}) ${phoneMatch[2]}-${phoneMatch[3]}-${phoneMatch[4]}` : "";
    }

    // Определение активного магазина
    this.address = this.salons.find((t) => t.id === this.formInfo.salon)?.address || "Любой";

    let service = [...(this.services || [])].find((t) => Boolean(String(t.id) === String(this.formInfo.service)));
    if (!service && this.uuid) {
      service = await this.$api.agent.transport.get(`/services/${ this.formInfo.service }`).then(res => res.data).catch(() => null);
    }
    this.service = service;


    const isSelectSalon = Boolean(!!this.formInfo.salon && this.formInfo.salon !== -1);
    const isSelectService = Boolean(!!this.formInfo.service && this.formInfo.service !== -1);

    this.onSetLocalForm();

    // Если пользователь выбрал все данные
    if (isSelectSalon && isSelectService) {} else {
      const currentDay = this.$moment().format("DD"); // Текущий день
      const currentHours = this.$moment().format("HH"); // Текущий час
      const currentMinuts = this.$moment().format("mm"); // Текущие минуты
      const currentHoursMinuts = Number(`${currentHours}${currentMinuts}`);

      const maxDates = 10; // Максимальное кол-во дней
      const entriesPerHour = 2; // Кол-во запесей в час
      const hourseStart = 9; // Со скольки начинать запись на прием
      const hourseEnd = 20; // Во сколько закончть прием

      // Инициализация времени записи на примем
      let workTime = {};

      // Начало диапазона времени записи
      const momentStartTime = this.$moment().set({
        hour: hourseStart,
        minute: 0,
      });

      // Проход по максимальному кол-ву дней
      for (let key = 0; key < maxDates; key++) {
        const dayMoment = this.$moment().add(key, "day");
        const day = dayMoment.format("DD");
        const dayFormat = this.$moment(dayMoment).format("YYYY-MM-DD");

        let times = [];

        for (
          let keyHourse = 0;
          keyHourse < hourseEnd - hourseStart;
          keyHourse++
        ) {
          for (let keyMinuts = 0; keyMinuts < entriesPerHour; keyMinuts++) {
            const begin = this.$moment(momentStartTime)
              .add(keyHourse, "h")
              .add(Boolean(keyMinuts === 0) ? 0 : 60 / (keyMinuts + 1), "m");
            const end = this.$moment(momentStartTime)
              .add(keyHourse, "h")
              .add(
                Boolean(keyMinuts === entriesPerHour - 1)
                  ? 60
                  : 60 / (keyMinuts + 2),
                "m"
              );

            if (
              currentDay === day &&
              Number(currentHoursMinuts) >
              Number(`${end.format("HH")}${end.format("mm")}`)
            ) {
              break;
            }

            const workTime = {
              begin: begin.format("HH:mm"),
              end: end.format("HH:mm"),
            };

            times.push(workTime);
          }
        }

        workTime[dayFormat] = times;
      }

      this.workTime = workTime;
      this.isAppointment = false;
    }

    this.isLoadingInitDate = false;
  },
  props: {
    formInfo: {type: Object},
    salons: {type: Array},
    services: {type: Array},
    uuid: {
      type: String,
      default: ""
    }
  },
  methods: {
    onChangeForm: function ({name, value}) {
      let newForm = {...this.form};
      newForm[name] = value;
      this.form = newForm;

      this.onSaveLocalForm(newForm);
    },
    openModal() {
      this.isModalOpen = true;
      this.$nextTick(() => {
        this.$modal.show("callback-modal");
      });
    },
    setApointmentTime(appointmentTime) {
      this.appointmentTime = appointmentTime;

      this.onSaveLocalForm();
    },
    async onSubmitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      } else {
        this.isSubmit = true;

        let ageMessage = "";
        if (this.formInfo.age === "2-6") {
          ageMessage = "Услуга для возраста: от 2 до 6 лет";
        }
        if (this.formInfo.age === "7-11") {
          ageMessage = "Услуга для возраста: от 7 до 11 лет";
        }
        if (this.formInfo.age === "12-18") {
          ageMessage = "Услуга для возраста: от 12 до 18 лет";
        }
        if (this.formInfo.age === "19") {
          ageMessage = "Услуга для возраста: старше 18 лет";
        }

        let form = {
          name: `${this.surname} ${this.patientName} ${this.middleName}`,
          phone: `7${this.phone.replace(/\D+/g, "")}`,
          service_id: this.formInfo.service,
          store_id: this.formInfo.salon,
          specialist_id: this.selectedSpecialist?.id,
          date: this.$moment(this.appointmentTime.day).format("YYYY-MM-DD"),
          begin: this.appointmentTime.start,
          end: this.appointmentTime.end,
          comment: ageMessage,
          email: this.email,
          additional_data: {
            mailing_agreement: this.mailingAgreement
          }
        };
        if (this.uid) {
          form.uid = this.uid;
        }

        if (!this.selectedSpecialist || this.selectedSpecialist?.id === -1) {
          delete form.specialist_id;
        }

        if (this.isAppointment) {
          try {
            const {data: res} = await this.$api.agent.transport.post("appointment", form);
            if (res) {
              this.isSubmit = false;

              this.onResetLocalForm();

              this.$emit('send', {
                ...form,
                selectedSpecialist: this.selectedSpecialist || null
              });

              try {
                await comagicAddOfflineRequest({
                  name: form.name,
                  email: form.email,
                  phone: form.phone,
                })
              } catch (err) {};

              try {
                if ((window?.Comagic) && Comagic.trackEvent) {
                  Comagic.trackEvent("Услуги", "Запись");
                }
              } catch (err) {};

              try {
                this.$vkGoalWr("DetailedRec", {}, process.env.vkPixelCode);
              } catch (err) {};

              try {
                const reachGoal = Boolean(this.isEmailRequired) ? 'zapispodrobnayaemail' : 'zapispodrobnaya';
                if (this.$yandexMetrika.reachGoal) {
                  this.$yandexMetrika.reachGoal(reachGoal);
                }
              } catch (err) {};

              // this.$router.push("/zapis/success");
            }
          } catch (error) {
            this.isSubmit = false;

            const {status} = error.response;

            if (status === 400) {
              this.$customNotification.error(
                "Запись на приём в выбранный период недоступна. Пожалуйста, укажите другое время",
                {
                  duration: 6000,
                }
              );
            } else {
              let errorMessage = [];
              if (Array.isArray(error.response?.data) && error.response?.data.length) {
                errorMessage = error.response?.data.map((t) => t.message);
              }
              if (!errorMessage.length) {
                errorMessage.push('Произошла ошибка')
              }

              this.$customNotification.error(errorMessage.join(';<br/>'), {
                duration: 6000,
              });
            }
          }
        } else {
          const dateFormat = (form.date || '').split('-').reverse().join('.');
          const ageTitle = this.$caseWords(this.childAge, ['год', 'года', 'лет']);

          let message = `Здравствуйте, хочу записаться на прием ${dateFormat} с ${form.begin} по ${form.end} на услугу ${this.services.find((t) => t.id === form.service_id)?.name}\nСалон: ${this.salons.find((t) => t.id === form.store_id)?.title || "Любой"}\n${ageMessage}`;

          const formSend = {
            type: "Запись на приём",
            phone: form.phone,
            name: form.name,
            message: message,
            email: this.email,
            additional_data: {
              mailing_agreement: this.mailingAgreement
            }
          };

          try {
            const {data: res} = await this.$api.agent.transport.post("form/send", formSend);
            this.onResetLocalForm();
            this.isSubmit = false;
            this.$emit('send', {
              ...form,
              selectedSpecialist: this.selectedSpecialist || null
            });

            try {
              const reachGoal = Boolean(this.isEmailRequired) ? 'zapispodrobnayaemail' : 'zapispodrobnaya';
              if (this.$yandexMetrika.reachGoal) {
                this.$yandexMetrika.reachGoal(reachGoal);
              }
            } catch (err) {};

            try {
              await comagicAddOfflineRequest({
                name: formSend.name,
                email: formSend.email,
                phone: formSend.phone,
                message: formSend.message,
              })
            } catch (err) {};

            // this.$router.push("/zapis/success");
          } catch (error) {
            this.isSubmit = false;

            const {status} = error.response;

            if (status === 400) {
              this.$customNotification.error(
                "Запись на приём в выбранный период недоступна. Пожалуйста, укажите другое время",
                {
                  duration: 6000,
                }
              );
            } else {
              this.$customNotification.error("Произошла ошибка", {
                duration: 6000,
              });
            }
          }
        }
      }
    },


    onSetLocalForm: function () {
      let zapisFormUser = localStorage.getItem('zapis-form-user');
      zapisFormUser = Boolean(!!zapisFormUser) ? JSON.parse(zapisFormUser) : {};

      this.form = zapisFormUser?.form || this.form || {};
      this.phone = zapisFormUser?.phone || this.phone || "";
      this.childAge = zapisFormUser?.childAge || this.childAge || "";
      this.patientName = zapisFormUser?.patientName || this.patientName || "";
      this.middleName = zapisFormUser?.middleName || this.middleName || "";
      this.surname = zapisFormUser?.surname || this.surname || "";
    },
    onSaveLocalForm: function () {
      let zapisFormUser = {};

      zapisFormUser.form = this.form;
      zapisFormUser.phone = this.phone;
      zapisFormUser.childAge = this.childAge;
      zapisFormUser.patientName = this.patientName;
      zapisFormUser.middleName = this.middleName;
      zapisFormUser.surname = this.surname;

      localStorage.setItem('zapis-form-user', JSON.stringify(zapisFormUser));
    },
    onResetLocalForm: function () {
      const selectedService = (this.services || []).find((t) => Boolean(String(t.id) === String(this.formInfo?.service)));

      try {
        const yandexMetrikaTarget = recordYandexMetrikaTarget[String(selectedService.category_id)];
        this.$yandexMetrika.reachGoal(yandexMetrikaTarget || 'record');
      } catch (err) {};

      try {
        this.$ga.event({
          eventCategory: 'event',
          eventAction: 'record',
          eventLabel: 'NA Записаться на прием'
        })
      } catch (err) {};

      localStorage.removeItem('zapis-form-user')
    },

    changeShowForm: function (val) {
      if (!val && this.uuid) {
        this.$emit("changeStage", 2);
        return
      }

      this.isShowForm = val;
    },

    changeSelectedSpecialist: function (option) {
      this.selectedSpecialist = option;
    }
  },
};
